const sPackage = (() => {
  return {
    getPackageLabel,
    getSizeLabels,
    getSizeValues,
    getPackageUsagePercentage,
    gb2str,
  };
  // /// PUBLIC /////////////////////////////////////////////////////////////////
  /**
   * Metoda wyciągająca pełną nazwę pakietu w zależności
   * czy jest pojedynczy lub podwójny.
   *
   * @method getPackageLabel(activePackage)
   * @param {Object} activePackage - pakiet z którego chcemy wyciągnąć nazwę
   * @access public
   */
  function getPackageLabel(activePackage) {
    let label = activePackage.usage_label === undefined ? activePackage.label : activePackage.usage_label;
    if (activePackage.more_than_one_feature === true) {
      return label.substring(label.indexOf(getSizeLabels(activePackage)[0]) + 1);
    }
    return label;
  }

  /**
   * Metoda wyciągająca nazwy pakietów dla podwójnych pakietów.
   *
   * @method getSizeLabels(activePackage)
   * @param {Object} activePackage - pakiet z którego chcemy wyciągnąć nazwy
   * @access public
   */
  function getSizeLabels(activePackage) {
    let label = activePackage.usage_label === undefined ? activePackage.label : activePackage.usage_label;
    if (activePackage.more_than_one_feature === true) {
      return [...label.matchAll(/[a-zA-Z]+ \d+/g)].slice(-2).map(x => ` ${String(x).split(' ')[0]}`);
    }
    return [''];
  }

  /**
   * Metoda zamieniająca rozzmiar w gigabajtach na odpowiednią czytelną wartość.
   *
   * @method gb2str(value)
   * @param {Number} value - pakiet z którego chcemy wyciągnąć nazwy
   * @access public
   */
  function gb2str(value) {
    const numberValue = Number(value);
    return (numberValue < (1000 / 1024)) ? `${parseFloat((numberValue * 1024).toFixed(1))} MB` : `${parseFloat(numberValue.toFixed(1))} GB`;
  }

  /**
   * Metoda zwracająca rozmiary w GB ze String'a z jednostką kB / MB / GB / TB
   *
   * @method getSizeFromString(strValue)
   * @param {String} strValue - pakiet z którego chcemy wyciągnąć wartości
   * @access public
   */
  function getSizesFromString(strValue) {
    const multiples = {
      k: 1 / (1024 * 1024),
      M: 1 / 1024,
      G: 1,
      T: 1024,
    };
    return Array.from(strValue.matchAll(/(\d+(\.\d+)?)([\s]*)([TGMk])B/g))
      .map(parts => multiples[parts[4]] * parseFloat(parts[1]));
  }

  /**
   * Metoda wyciągająca wartości w GB danego pakietu.
   *
   * @method getSizeValues(activePackage)
   * @param {Object} activePackage - pakiet z którego chcemy wyciągnąć wartości
   * @access public
   */
  function getSizeValues(activePackage) {
    let label = activePackage.usage_label === undefined ? activePackage.label : activePackage.usage_label;
    if (activePackage.more_than_one_feature === true) {
      return getSizesFromString(label).slice(-2);
    }
    return [getSizesFromString(label)[0]];
  }

  /**
   * Metoda Obliczająca procentowe zużycie pakietu.
   *
   * @method getPackageUsagePercentage(activePackage, packageUsage)
   * @param {Object} activePackage - pakiet dla którego chcemy obliczyć zużycie
   * @param {Object} packageUsage  - wartości zużycia pakietów
   * @access public
   */
  function getPackageUsagePercentage(activePackage, packageUsage) {
    const remainingUnits = Object.values(packageUsage);
    const packageSize = getSizeValues(activePackage);
    return packageSize.map((size, index) => Math.min(100, Math.floor((remainingUnits[index] / size) * 100)));
  }
})();

export default sPackage;



// WEBPACK FOOTER //
// ./src/services/sPackage.js